export const normalizeLabelForClass = (label: string): string => {
    const arrayLabel = label.trim().split(' ').filter(Boolean);

    if (arrayLabel.length > 1) {
        return arrayLabel.join('-').toLowerCase();
    }

    return label.trim().toLowerCase();
};
